module.exports = __webpack_public_path__ + "static/img/rank_167.67a2311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_167.png
// module id = yBwT
// module chunks = 0